import {GridGetRowsError, GridUpdateRowError} from "@mui/x-data-grid-premium";
import type {AxiosError} from "axios";
import {isAxiosError} from "axios";
import {axiosErrorToString} from "../../../utils/axios.utils.ts";
import type AuthStore from "../../../authentication/AuthStore.tsx";
import {action, makeObservable, observable} from "mobx";

export class BaseMuixPageController {
    errorMessage: string = '';

    constructor(
        // Note that declaring this as private would result in this error
        //      Types have separate declarations of a private property
        protected auth: AuthStore,
    ) {
        makeObservable(this, {
            errorMessage: observable,
            onNoError: action,
            onError: action,
        });
    }

    onNoError() {
        this.errorMessage = ''
    }

    onError(error: GridUpdateRowError | GridGetRowsError | AxiosError | Error | undefined) {
        this.errorMessage = this.getErrorMessage(error);
    }

    private getErrorMessage(error: GridUpdateRowError | GridGetRowsError | AxiosError | Error | undefined, fallbackMessage?: string): string {
        if (!error) {
            return fallbackMessage ?? 'Unknown error'
        }
        if (isAxiosError(error)) {
            if (this.auth.isMithraStaff && error.response?.data) {
                const errorItems = error.response.data?.filterModel?.items;
                if (Array.isArray(errorItems)) {
                    return 'FilterModel.items: ' + errorItems.filter(i => i).map(item => `${item.message ?? JSON.stringify(item)}`).join(', ')
                }
                return axiosErrorToString(error)
            }
            return error.message
        }
        if (error instanceof GridGetRowsError) {
            return this.getErrorMessage(error.cause, error.message)
        }
        if (error instanceof GridUpdateRowError) {
            return this.getErrorMessage(error.cause, error.message)
        }
        return fallbackMessage ?? String(error)
    }
}